module.exports = __webpack_public_path__ + "static/media/preloader.584b607f.gif";